import React from 'react';

import classNames from 'classnames';
import {observer} from 'mobx-react';

import styles from './SlideContainer.module.scss';

export type NextActionReturn = boolean | 'nextPhase';
export type BackActionReturn = boolean | 'previousPhase';

export interface SlideContainerProps {
    validation?: () => boolean;
    nextAction?: () => NextActionReturn;
    nextActionAsync?: () => Promise<NextActionReturn>;
    backAction?: () => BackActionReturn;
    backActionAsync?: () => Promise<BackActionReturn>;
    onView?: () => void;
    slideName: string;
    /**
     * True when this slide only renders because of a previous answer. Reaching it therefore
     * discloses that answer, so analytics report a generic name instead of the real one.
     */
    isConditionalSlide?: boolean;
    hideNavigation?: boolean;
    withoutLimit?: boolean;
    disableAutoSlide?: boolean;
    disableAutoHeight?: boolean;
    noPadding?: boolean;
    noMargin?: boolean;
    customNextButtonText?: string | React.ReactElement;
    wideButton?: boolean;
    hideProgressBar?: boolean;
    additionalButton?: React.ReactElement;
    className?: string;
    inRow?: boolean;
    children?: React.ReactNode;
    forceAutoSlide?: boolean;
    setForceAutoSlide?: (val: boolean) => void;
    showSnackBar?: boolean;
    autoOpenKeyboard?: string;
    title?: string;
    revertedOrder?: boolean;
    withDrawer?: boolean;
    analyticsProps?: {
        action: string;
        data?: Record<string, string | number | string[]>;
    };
}

const SlideContainer: React.FC<SlideContainerProps> = ({
    withoutLimit,
    noPadding,
    hideProgressBar,
    className,
    children,
    noMargin = false,
}) => {
    return (
        <div
            className={classNames(styles.SlideContainer, className, {
                [styles.noPadding]: noPadding,
                [styles.noMargin]: hideProgressBar || noMargin,
            })}
        >
            <div
                className={classNames(styles.SlideContainerLimit, {
                    [styles.withoutLimit]: withoutLimit,
                })}
            >
                {React.Children.map(children, (child) => child)}
            </div>
        </div>
    );
};

export default observer(SlideContainer);
